/* unplugin-vue-components disabled */import script from "./Menus.vue?vue&type=script&lang=ts&setup=true"
export * from "./Menus.vue?vue&type=script&lang=ts&setup=true"

import "./Menus.vue?vue&type=style&index=0&id=398c69c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-398c69c0"]])

export default __exports__